<div>

  <div class="info-text">
    <span class="syn-body--medium">
      Simply upload your Safety Designer project file (.sdp), and our service will process it and return the converted file with the .sdp2 extension.
      <br>
      <br>
      The project content remains untouched. The checksums will remain the same after the conversion of the project file format.
    </span>
  </div>

  <div>
    <app-file-upload />
  </div>

</div>
